import { WORKER_IMAGE_CANVAS_TO_BLOB } from './constants/events';
import { base64ToBlob } from './workers/image';
onmessage = function (event) {
    if (!event.data.type) {
        return;
    }
    const type = event.data.type;
    let data;
    switch (type) {
        case WORKER_IMAGE_CANVAS_TO_BLOB:
            data = base64ToBlob(event.data.data);
            break;
    }
    postMessage({ type, data });
};
